/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getInvitationsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "email": zod.string(),
  "role": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "isActive": zod.boolean(),
  "acceptedDate": zod.string().datetime({}).nullish(),
  "isAccepted": zod.boolean(),
  "declinedDate": zod.string().datetime({}).nullish(),
  "isDeclined": zod.boolean(),
  "expiryDate": zod.string().datetime({}),
  "lastSentDate": zod.string().datetime({}),
  "createdDate": zod.string().datetime({})
})
export const getInvitationsResponse = zod.array(getInvitationsResponseItem)

export const createInvitationBody = zod.object({
  "email": zod.string(),
  "roleCode": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent'])
})

export const cancelInvitationParams = zod.object({
  "id": zod.string().uuid()
})

export const resendInvitationParams = zod.object({
  "id": zod.string().uuid()
})

export const resendInvitationResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "email": zod.string(),
  "role": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "isActive": zod.boolean(),
  "acceptedDate": zod.string().datetime({}).nullish(),
  "isAccepted": zod.boolean(),
  "declinedDate": zod.string().datetime({}).nullish(),
  "isDeclined": zod.boolean(),
  "expiryDate": zod.string().datetime({}),
  "lastSentDate": zod.string().datetime({}),
  "createdDate": zod.string().datetime({})
})

export const dismissInvitationParams = zod.object({
  "id": zod.string().uuid()
})

export const dismissAllCompletedResponse = zod.object({
  "dismissedCount": zod.number()
})

